import { styled, Box } from '@mui/material';

export const AssistantGenerateRoutesDialogByTemplateContentFormTableContainer =
  styled(Box)({
    marginTop: 6,
    overflowY: 'auto',
    height: '100%',
    maxHeight: 230,
    minHeight: 180,

    '& .data-table-container': {
      display: 'grid',
      gridTemplateRows: '1fr max-content',

      '& ._loading_overlay_wrapper': {
        height: '100%',
      },
    },
  });
